import React, { useState } from 'react';
import api from '../../../../../../services/api';
import { useToast } from '../../../../../../hooks/Toast';

import { useAuth } from '../../../../../../hooks/Auth';
import { FiSend } from 'react-icons/fi';
import { FaBarcode, FaCopy, FaFileExcel, FaQrcode, FaReceipt } from 'react-icons/fa';
import { useConfiguration } from '../../../../../../hooks/Configuration';
import { date, dateSimple, dateSimpleBRWithHour, month, simpleDateBR } from '../../../../../../utils/date';
import { formatReal } from '../../../../../../utils/format';
import { downloaditPost } from '../../../../../../utils/download';
import { apiUrl } from '../../../../../../config';
import { useLoading } from '../../../../../../hooks/LoadingHook';
import { FormHandles } from '@unform/core';
import { sanitizeData } from 'src/pages/DashboardPages/core/components/FormComponent';
import FormComponent from 'src/pages/DashboardPages/core/components/FormComponent';
import { uuid } from 'uuidv4';
import { useModal } from 'src/hooks/Modal';
 
import MaskedCurrencyInput from 'src/components/Forms2025/MaskedCurrencyInput';
import SelectSimple from 'src/components/Forms2025/SelectSimple';
import DatePicker from 'src/components/Forms2025/DatePicker';
import { addMonths } from 'date-fns';
import Form from 'src/components/UIComponents/Form';

interface ICreateModule {
  lineData: Record<string, any>;
}

const Content = ({lineData, invoiceValue,products}) => {

  const { addToast } = useToast();
  const {addModal, removeModal} = useModal();
  const { addLoading, removeLoading } = useLoading();
  const { configuration } = useConfiguration();



  const prepareDuplicate = async (data) => {


    const item = await api.get(`/sales-invoice/${lineData?._id?.toString()}`);

    const content = {...data};

content.product_id = lineData?.product_id;
content.product_id_response = lineData?.product_id_response;

content.payment_method_id = lineData?.payment_method_id;
    content.project_id = item?.data?.project_id;
    content.event_id = item?.data?.event_id;

    content.sale_hash = item?.data?.sale_hash;
    content.invoice_hash = uuid();
    content.client_id = item?.data?.client_id_response?._id?.toString();
    content.client_id_response = item?.data?.client_id_response;

     content.payer_id = item?.data?.payer_id_response?._id?.toString();
    content.payer_id_response = item?.data?.payer_id_response || {};
    content.payment_status_id = 'waiting';

    content.juros = sanitizeData.currencyInput(data?.juros);
    content.price = sanitizeData.currencyInput(data?.price);
    content.multa = sanitizeData.currencyInput(data?.multa);

    content.installment_number = data?.installment_number;
 
    content.installment_value = sanitizeData.currencyInput(data?.total);

    try{
   await api.post(`/sales-invoice`, content);

    addToast({title: 'Inserido com sucesso', type: 'success'});
  
    }
    catch(err){
      addToast({title: 'Erro ao inserir', type: 'error'});
    }


  }




  const prepareDuplicateGlobal = async (list) => {


    let x = 0;

    while(x < list?.length ){

      const item = list[x];
      await prepareDuplicate(item)
addToast({title: `Parcela ${item?.installment_number} emitido.`})
      x+=1;
    }


    removeModal('modal');
           removeModal('modal2')

  }


  const confirmarCobranca = ( list) => {


    addModal({title:'',key:'modal2', theme:'whiteModal', content: <div className='column gap-xs'>


       <h2 style={{ fontSize:'16px', color: '#333', textAlign:'left', width: '100%'}}>Confirmar cobrança?</h2>
    

   <p style={{ fontSize:'16px', color: '#333', textAlign:'left', width: '100%'}}>Parcelamento:</p>
    
       <table  className='tableRef'>
        <tbody>
<tr><td>Parcela</td><td>Data</td><td>Cobrança</td><td>Juros</td><td>Multa</td><td>Total</td></tr>
        {list?.map( line => {

          return <tr>

<td>{ line?.installment_number }</td>
          <td>{simpleDateBR(line?.payment_date)}</td>
          <td style={{textAlign:'right'}}>R$ {formatReal(line?.value)}</td>
          <td style={{textAlign:'right'}}>R$ {formatReal(line?.juros)}</td>
          <td style={{textAlign:'right'}}>R$ {formatReal(line?.multa)}</td>
          <td style={{textAlign:'right'}}>R$ {formatReal(line?.total)}</td>

          </tr>


        })}


          <tr><td colSpan={5}><strong> Total geral</strong></td><td ><strong>R$ {formatReal(total*value.months)}</strong></td></tr>
       
        </tbody>


    </table>


<button className='defaultButton' onClick={() => {


prepareDuplicateGlobal(list)



}}>Sim</button>

    </div>})


  } 
 



    const [value, setValue] = useState({

      value: invoiceValue?.data?.installment_value,
      months_late: 1,
      months: 1,
      juros: 1,
      multa: 2,
      payment_date: invoiceValue?.data?.payment_date


    });



     const options : any = [];

     products?.data?.rows?.map( item => {

      options.push({label: item?.title, value: item?._id?.toString()})


     })

const callback = (string, form: React.RefObject<FormHandles>) => {
  const installments = form?.current?.getFieldValue('installment') || 1;

  const discount =
    sanitizeData.currencyInput(form?.current?.getFieldValue('discount')) || 0;

  const total =
    sanitizeData.currencyInput(form?.current?.getFieldValue('total')) || 0;

  const installmentValue = parseInt(
    ((total - discount) / installments).toString(),
    10,
  );

  form?.current?.setFieldValue('installment_value', installmentValue);
};


const getCalculus = (price, juros, months) => {

  if(!juros || !price){
    return 0;
  }

  return price * ((juros * months) / 100);

}



const getInstallments = ({price, total, juros, multa,  payment_date, months, installment_number} ) => {

  const contentItems : Record<string,any>[] = [];

  let x = 1;

  while (x <= months){

    contentItems.push({
installment_number : x === 1 ? installment_number : installment_number + (x-1),
      price: price,
      juros : juros,
      multa : multa,
      total: total,
      payment_date : x === 1 ? new Date(payment_date) : addMonths(new Date(payment_date), x-1)
       
    })

    x += 1;
  }


  

  return contentItems;

}



const price =  parseInt(value?.value?.toString().replace(/[^0-9]/g, ''),10) ;
const multa =  parseInt((value?.months_late < 1 ? 0 : getCalculus(price, value?.multa, 1) )?.toString(),10);
const juros =  parseInt((value?.months_late < 1  ? 0 : getCalculus(price, value?.juros, value?.months_late) < 1 ? 0 : getCalculus(price, value?.juros, value?.months_late))?.toString(),10);

const total =  price + multa + juros;





 return <div className='row-to-column gap-xs'><Form style={{maxWidth: '300px'}} key={'modal-price'} onSubmit={() => {}} initialData={{...value}}>


<MaskedCurrencyInput setCallback={(valueItem) => {


setValue(state => ({...state, value: valueItem}));

}} name='value' placeholder='Valor da cobrança'/>


<SelectSimple index={1}  setCallback={(valueItem) => {

if(value.months_late !== valueItem){
setValue(state => ({...state, months_late: valueItem}));
}

}} name='months_late' label='Meses de atraso' options={[
  
  { label: 'Sem cobrança adicional', value: -1 },
  { label: '1', value: 1 },
        { label: '2', value: 2 },
        { label: '3', value: 3 },
        { label: '4', value: 4 },
        { label: '5', value: 5 },
        { label: '6', value: 6 },
        { label: '7', value: 7 },
        { label: '8', value: 8 },
        { label: '9', value: 9 },
        { label: '10', value: 10 },
        { label: '11', value: 11 },
        { label: '12', value: 12 }]}/> 


<SelectSimple index={2} setCallback={(valueItem) => {

if(value.months !== valueItem){
setValue(state => ({...state, months: valueItem}));
}

}} name='months' label='Aplicar cobrança em meses' options={[ { label: '1', value: 1 },
        { label: '2', value: 2 },
        { label: '3', value: 3 },
        { label: '4', value: 4 },
        { label: '5', value: 5 },
        { label: '6', value: 6 },
        { label: '7', value: 7 },
        { label: '8', value: 8 },
        { label: '9', value: 9 },
        { label: '10', value: 10 },
        { label: '11', value: 11 },
        { label: '12', value: 12 }]}/> 

<DatePicker setCallback={(valueItem) => {


setValue(state => ({...state, payment_date: valueItem}));

}} name='payment_date' placeholder='Data de vencimento' />

<SelectSimple index={3} setCallback={(valueItem) => {

if(value.juros !== valueItem){
setValue(state => ({...state, juros: valueItem}));
}

}} name='juros' label='% de juros / mês' options={[
  { label: '0', value: 0 },
  { label: '1', value: 1 },
        { label: '2', value: 2 },
        { label: '3', value: 3 },
        { label: '4', value: 4 },
        { label: '5', value: 5 },
        { label: '6', value: 6 },
        { label: '7', value: 7 },
        { label: '8', value: 8 },
        { label: '9', value: 9 },
        { label: '10', value: 10 },
        { label: '11', value: 11 },
        { label: '12', value: 12 }]}/>


<SelectSimple index={4} setCallback={(valueItem) => {

if(value.multa !== valueItem){
setValue(state => ({...state, multa: valueItem}));
}

}} name='multa' label='% de multa / mês' options={[
    { label: '0', value: 0 },
  { label: '1', value: 1 },
        { label: '2', value: 2 },
        { label: '3', value: 3 },
        { label: '4', value: 4 },
        { label: '5', value: 5 },
        { label: '6', value: 6 },
        { label: '7', value: 7 },
        { label: '8', value: 8 },
        { label: '9', value: 9 },
        { label: '10', value: 10 },
        { label: '11', value: 11 },
        { label: '12', value: 12 }]}/>




    </Form> 
    
    <div className='column gap-xs' style={{maxWidth:'600px'}}>

<h2 style={{ fontSize:'16px', color: '#333', textAlign:'left', width: '100%'}}>Simulação:</h2>

    <table className='tableRef'>
        <tbody>
          <tr><td>Valor</td><td style={{textAlign:'right'}}>R$ {formatReal(price)}</td></tr>
          <tr><td>Juros</td><td style={{textAlign:'right'}}>R$ {formatReal(juros)}</td></tr>
          <tr><td>Multa</td><td style={{textAlign:'right'}}>R$ {formatReal(multa)}</td></tr>
          <tr><td>Total</td><td style={{textAlign:'right'}}>R$ {formatReal(total)}</td></tr>
        </tbody>


    </table>

    <h2 style={{ fontSize:'16px', color: '#333', textAlign:'left', width: '100%'}}>Parcelamento:</h2>
    
       <table  className='tableRef'>
        <tbody>
<tr><td>Parcela</td><td>Data</td><td>Cobrança</td><td>Juros</td><td>Multa</td><td>Total</td></tr>
        {getInstallments({...value, price  , total, juros, multa, installment_number : lineData?.installment_number})?.map( line => {

          return <tr>

<td>{ line?.installment_number }</td>
          <td>{simpleDateBR(line?.payment_date)}</td>
          <td style={{textAlign:'right'}}>R$ {formatReal(line?.value)}</td>
          <td style={{textAlign:'right'}}>R$ {formatReal(line?.juros)}</td>
          <td style={{textAlign:'right'}}>R$ {formatReal(line?.multa)}</td>
          <td style={{textAlign:'right'}}>R$ {formatReal(line?.total)}</td>

          </tr>


        })}


          <tr><td colSpan={5}><strong> Total geral</strong></td><td ><strong>R$ {formatReal(total*value.months)}</strong></td></tr>
       
        </tbody>


    </table>


<button className='defaultButton' onClick={() => {


confirmarCobranca(getInstallments({...value, price  , total, juros, multa, installment_number : lineData?.installment_number}))



}}>Gerar cobrança</button>

    </div>

    
    </div>


 

}

export default function UpdateModule({lineData})  {
  const { handleApiErrors } = useAuth();
  const { addToast } = useToast();
  const {addModal, removeModal} = useModal();
  const { addLoading, removeLoading } = useLoading();
  const { configuration } = useConfiguration();


  const createModal = async () => {


     const products =  await api.get(`/products`, {params: { where: { project_id : lineData?.project_id}}});
  const invoiceValue = await api.get(`/sales-invoice/${lineData?._id?.toString()}`);


    addModal({title: '', theme:'whiteModal', key: 'modal', content: <><p>Nova cobrança</p>
    <p>{lineData?.client_id_response?.name}</p>




    <Content products={products} invoiceValue={invoiceValue} lineData={lineData}/>
    
    </>})




  }


  const moduleUpdate = (): JSX.Element => (
    <button className="lineIcon" title="Gerar nova cobrança" onClick={() => { createModal() }} type="button"  >
      <FaBarcode color='red' />
    </button>
  );

  return moduleUpdate();
}
